import React from 'react';
import './OrderCollapsibleSection.css';

const OrderCollapsibleSection = ({
  title,
  count,
  collapsed,
  onToggle,
  children,
  highlight = false,
}) => (
  <div className={`order-collapsible-section ${highlight ? 'highlight' : ''}`}>
    <button
      type="button"
      className="order-collapsible-header"
      onClick={onToggle}
      aria-expanded={!collapsed}
    >
      <span className="order-collapsible-title">
        {title}
        {count != null && count > 0 && (
          <span className="order-collapsible-count">({count})</span>
        )}
      </span>
      <span className="order-collapsible-icon">{collapsed ? '▼' : '▲'}</span>
    </button>
    {!collapsed && (
      <div className="order-collapsible-body">
        {children}
      </div>
    )}
  </div>
);

export default OrderCollapsibleSection;
